import { Link, useLocation } from 'react-router-dom';
import { StringLights } from './StringLights';
import { useState } from 'react';
import { Menu, X, Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const Navbar = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { language, toggleLanguage, t } = useLanguage();
  
  const navLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/rsvp', label: t('nav.rsvp') },
    { path: '/schedule', label: t('nav.details') },
    { path: '/travel', label: t('nav.travel') },
    { path: '/dress-code', label: t('nav.dressCode') },
    { path: '/gallery', label: t('nav.gallery') }
  ];

  return (
    <>
      <StringLights />
      <nav className="fixed top-0 left-0 right-0 z-50 cream-bg border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="flex justify-between items-center py-4 md:py-6">
            {/* Left - Couple names and date */}
            <Link to="/" className="flex flex-col" onClick={() => setMobileMenuOpen(false)}>
              <h1 className="font-serif text-3xl md:text-5xl font-bold blue-text leading-none mb-1">
                POLINA
              </h1>
              <h1 className="font-serif text-3xl md:text-5xl font-bold blue-text leading-none mb-2">
                & EVGENIY
              </h1>
              <p className="font-sans text-xs md:text-sm blue-text tracking-widest">07.09.2026</p>
            </Link>
            
            {/* Mobile: Language Switcher + Menu Button */}
            <div className="lg:hidden flex items-center gap-3">
              {/* Mobile Language Toggle - Always Visible */}
              <button
                onClick={toggleLanguage}
                className="flex items-center gap-1.5 px-2.5 py-1.5 border-2 border-primary blue-text hover:blue-bg hover:text-white transition-all"
                aria-label="Toggle language"
              >
                <Globe className="w-4 h-4" />
                <span className="font-sans text-xs tracking-widest font-semibold">
                  {language === 'en' ? 'RU' : language === 'ru' ? 'BG' : 'EN'}
                </span>
              </button>
              
              {/* Mobile Menu Button */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="p-2 blue-text"
                aria-label="Toggle menu"
              >
                {mobileMenuOpen ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
              </button>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`font-sans text-xs tracking-wide transition-all whitespace-nowrap ${
                    location.pathname === link.path
                      ? 'blue-text underline underline-offset-4'
                      : 'text-muted-foreground hover:blue-text hover:underline underline-offset-4'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              
              {/* Language Toggle */}
              <button
                onClick={toggleLanguage}
                className="flex items-center gap-2 px-3 py-2 border-2 border-primary blue-text hover:blue-bg hover:text-white transition-all"
                aria-label="Toggle language"
              >
                <Globe className="w-4 h-4" />
                <span className="font-sans text-xs tracking-widest font-semibold">
                  {language === 'en' ? 'RU' : language === 'ru' ? 'BG' : 'EN'}
                </span>
              </button>
            </div>
          </div>

          {/* Mobile Navigation Menu */}
          {mobileMenuOpen && (
            <div className="lg:hidden border-t border-primary py-4 mb-4">
              <div className="flex flex-col space-y-4">
                {navLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    onClick={() => setMobileMenuOpen(false)}
                    className={`font-sans text-sm tracking-wider py-2.5 px-3 text-center border-2 transition-all ${
                      location.pathname === link.path
                        ? 'blue-bg text-white border-primary'
                        : 'cream-bg blue-text border-primary hover:blue-bg hover:text-white'
                    }`}
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </nav>
      
      {/* Overlay when mobile menu is open */}
      {mobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}
    </>
  );
};
